'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024164 from "./presto.types$-Two-Factor-Auth-Name$$anon$164.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024165 from "./presto.types$-Two-Factor-Auth-Name$$anon$165.js";
var $p;
/** @constructor */
function $c_Lpresto_types$TwoFactorAuthName$() {
  this.cd6 = null;
  this.cd7 = false;
  this.cd4 = null;
  this.cd5 = false;
  this.cda = null;
  this.cdb = false;
  this.cd8 = null;
  this.cd9 = false;
  this.cdc = null;
  this.cdd = false;
}
export { $c_Lpresto_types$TwoFactorAuthName$ as $c_Lpresto_types$TwoFactorAuthName$ };
$p = $c_Lpresto_types$TwoFactorAuthName$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$TwoFactorAuthName$;
/** @constructor */
function $h_Lpresto_types$TwoFactorAuthName$() {
}
export { $h_Lpresto_types$TwoFactorAuthName$ as $h_Lpresto_types$TwoFactorAuthName$ };
$h_Lpresto_types$TwoFactorAuthName$.prototype = $p;
$p.cJt = (function() {
  if ((!this.cd7)) {
    this.cd6 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.cd7 = true;
  }
  return this.cd6;
});
$p.zt = (function() {
  if ((!this.cd5)) {
    this.cd4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.cd5 = true;
  }
  return this.cd4;
});
$p.a3b = (function() {
  if ((!this.cdb)) {
    this.cda = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.cdb = true;
  }
  return this.cda;
});
$p.ct5 = (function() {
  if ((!this.cd9)) {
    this.cd8 = new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024164.$c_Lpresto_types$TwoFactorAuthName$$anon$164(this);
    this.cd9 = true;
  }
  return this.cd8;
});
$p.a3i = (function() {
  if ((!this.cdd)) {
    this.cdc = new $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dName$0024$0024anon$0024165.$c_Lpresto_types$TwoFactorAuthName$$anon$165(this);
    this.cdd = true;
  }
  return this.cdc;
});
var $d_Lpresto_types$TwoFactorAuthName$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$TwoFactorAuthName$, "presto.types$TwoFactorAuthName$", ({
  a2q: 1,
  D: 1
}));
export { $d_Lpresto_types$TwoFactorAuthName$ as $d_Lpresto_types$TwoFactorAuthName$ };
var $n_Lpresto_types$TwoFactorAuthName$;
function $m_Lpresto_types$TwoFactorAuthName$() {
  if ((!$n_Lpresto_types$TwoFactorAuthName$)) {
    $n_Lpresto_types$TwoFactorAuthName$ = new $c_Lpresto_types$TwoFactorAuthName$();
  }
  return $n_Lpresto_types$TwoFactorAuthName$;
}
export { $m_Lpresto_types$TwoFactorAuthName$ as $m_Lpresto_types$TwoFactorAuthName$ };
//# sourceMappingURL=presto.types$-Two-Factor-Auth-Name$.js.map
